import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { PaymentInstallment } from 'src/app/entities/payment-installment';
import { BaseAddComponent } from '../base-add/base-add.component';
import { PaymentInstallmentService } from 'src/app/services/payment-installment.service';
import { AlertService } from 'src/app/services/alert.service';
import { ActivatedRoute, Router } from '@angular/router';
import { fuseAnimations } from '@mobileia/layout-fuse';

@Component({
  selector: 'app-payment-installment-add',
  templateUrl: './payment-installment-add.component.html',
  styleUrls: ['./payment-installment-add.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class PaymentInstallmentAddComponent extends BaseAddComponent<PaymentInstallment> implements OnInit {

  pathUrlList = 'payment-installment';
  categoriesParents = new Array<PaymentInstallment>();

  constructor(
    protected installmentService: PaymentInstallmentService,
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router
  ) {
    super(alertService, route, navigator);
    this.service = installmentService;
    this.item = new PaymentInstallment();
    this.initFields();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  initFields() {
    this.configFields = [
      {
        type: 'string',
        key: 'title',
        title: 'Titulo',
        caption: ''
      },
      {
        type: 'select',
        key: 'type',
        title: 'Tipo',
        caption: '',
        options: [
          {
            title: 'FirstData',
            value: 0
          },
          {
            title: 'MutualCard',
            value: 1
          },
        ]
      },
      {
        type: 'string',
        key: 'percent',
        title: 'Porcentaje interes',
        caption: ''
      },
      {
        type: 'string',
        key: 'installment',
        title: 'Numero de cuotas',
        caption: '',
        placeholder: '1'
      },
    ];
  }

}